import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.freeze.js";
// This file is a modified version of packages/ab-common/src/api/grades.ts

import { axiosInstance } from '@applyboard/ui-utils';
// eslint-disable-next-line  @typescript-eslint/no-explicit-any
var emptyApiResponse = function emptyApiResponse() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return Promise.resolve(Object.freeze({
    data: data,
    headers: {},
    status: 0
  }));
};
export var apiEducationLevels = function apiEducationLevels() {
  return axiosInstance.get('/api/grades/education_levels');
};

// eslint-disable-next-line  @typescript-eslint/no-explicit-any
var isNullOrUndefined = function isNullOrUndefined(param) {
  return param === null || param === undefined;
};
export var apiMinGrade = function apiMinGrade(params) {
  if (!params) {
    return emptyApiResponse();
  }
  var scheme_id = params.scheme_id,
    program_id = params.program_id,
    grade = params.grade;
  if (isNullOrUndefined(scheme_id) || isNullOrUndefined(program_id) || isNullOrUndefined(grade)) {
    return emptyApiResponse();
  }
  return axiosInstance.get("/api/grades/grade_eligibility", {
    params: params
  });
};